const messages = {
    en: {
        translations: {
            btn_access: {
                menu: 'Mobile menu',
                title_en: 'Change language to English',
                title_pt: 'Change language to Brazilian Portuguese'
            },
            ola: {
                ola: "Hi, I'm \nAndré Akira"
            },
            dev: {
                front: 'Front-end Developer'
            },
            buscar: {
                buscar: "Search..."
            },
            nav: {
                sobre: 'About',
                historico: 'History',
                habilidades: "Skills",
                portfolio: "Portfolio",
                hobbies: "Hobbies",
                contato: "Contact"
            },
            titles: {
                psobre: 'About me',
                psobre2: 'Personality Test',
                phistorico: 'Professional history',
                phabilidades: 'Skill and tools',
            },
            conteudo: {
                psobre: 'I started studying Systems Development at SENAI Informática in August 2019 and since then I have focused on my training as a developer, thus taking several courses in parallel. I intend to continue in the area of ​​web development with Front-end.',
                psobreDisc: {
                    titles: 'DISC - Conscientiousness',
                    msg: 'A person in this DiSC quadrant places emphasis on quality and accuracy, expertise and competency. They enjoy their independence, demand the details, and often fear being wrong. ',
                    btn1: 'Reference',
                    btn2: 'Close'
                },
                psobreTeste: {
                    titles: 'Behavioral Profile - Wolf',
                    msg: "It's the organizer. Always attentive to planning, punctuality and control. Detailed, conservative, methodical, still predictable, loyal, with difficulty adapting to changes and responsible for carrying out the agreement, are some of his characteristics.",
                    btn1: 'Reference',
                    btn2: 'Close'
                },
                psobrePerso: {
                    titles: '16Personalities - Architect INTJ-T',
                    msg: "It can be lonely at the top. As one of the rarest personality types – and one of the most capable – Architects (INTJs) know this all too well. Rational and quick-witted, Architects may struggle to find people who can keep up with their nonstop analysis of everything around them.",
                    btn1: 'Reference',
                    btn2: 'Close'
                }
            },
            cargos: {
                cargo1: 'Trainee',
                cargo2: 'Web developer',
                cargo3: 'Web Designer Developer',
                cargo4: 'Web developer',
                cargo5: 'Front-end Developer',
                cargo6: 'Middle Developer',
            },
            duracao: {
                duracao1: '2 months',
                duracao2: '1 year and 4 months',
                duracao3: '4 months',
                duracao4: '2 months',
                duracao5: '2 year and 4 months'
            },
            duracao: {
                duracao1: {
                    num: 2,
                    time: 'months'
                },
                duracao2: {
                    num: 16,
                    time: 'months'
                },
                duracao3: {
                    num: 4,
                    time: 'months'
                },
                duracao4: {
                    num: 2,
                    time: 'months'
                },
                status: 'Currently working ✔️',
                duracaoTempo: "year",
            },
            tempoExp: "Time experience: ",
            projetos: {
                titulo: "Projects completed",
                botao: "Visit here"
            },
            hobbies: {
                titulo: "Hobbies and leisure",
                game1: "Front-box",
                game2: "Jo-ken-po RPG",
                game3: "Game Memory",
                game4: "Soccer Goal",
                game5: "Bug Swat",
                game6: "Tic Tac Toe",
                traducao: "Generators",
                generator1: "Mega Senna Numbers",
                generator2: "Generator Commit Plugin WP",
                generator3: "Numbers generator",
            },
            contato: {
                titulo: "Contact me",
                labels: {
                    nome: "Name*",
                    email: "Email*",
                    assunto: "Subject*",
                    mensagem: "Message*"
                },
                botao: "Send",
                msgs: {
                    enviado: "Sent with success",
                    erro: "Something wrong, try again..."
                }
            }
        }
    }
}

export { messages }